// React Dependencies
import React, { useEffect } from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Grid, Typography } from '@material-ui/core';

// Internal Dependencies
import SelectMall from './selectMall';
import SelectStore from './selectStore';
import UploadDetails from './uploadDetails';
import { IsEmpty } from '../../../common/checks';

const UploadScrappedPromo = (props) => {
  useEffect(() => {
    console.log('Props.mall=');
    console.log(props.mall);
  }, []);

  return (
    <div style={{ flexGrow: 1, flex: 1 }}>
      <Grid container direction="row">
        <Typography variant="subtitle1" style={{ marginBottom: 10 }}>
          {!IsEmpty(props.mall) ? props.mall.name : ''}
        </Typography>
        <Typography variant="subtitle1" style={{ marginBottom: 10 }}>
          {!IsEmpty(props.store.name) ? ` / ${props.store.name}` : ''}
        </Typography>
      </Grid>

      {
        IsEmpty(props.mall.name)
          ? <SelectMall />
          : IsEmpty(props.store.name) ? <SelectStore /> : <UploadDetails />
      }

    </div>
  );
};

const mapStateToProps = (state) => ({
  mall:  state.admin.uploadScrappedPromo.mall,
  store: state.admin.uploadScrappedPromo.store,
});

UploadScrappedPromo.propTypes = {
  mall: PropTypes.shape({
    id:   PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
  }).isRequired,

  store: PropTypes.shape({
    id:         PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name:       PropTypes.string,
    outletId:   PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    postalCode: PropTypes.string,
  }).isRequired,
};

export default connect(mapStateToProps, null)(UploadScrappedPromo);
